angular.module('webremote.dashboard').controller('widget_quickRecord', 
function ($scope, $log) {

    // TODO

});
